import type { LayoutPageConfig } from './types';

export const dataPageConfig = {
  namespacesRequired: ['import'],
  layout: {
    showHeaderPeriodFilter: false,
  },
} satisfies LayoutPageConfig;
